<div class="language-word">
    <h5 [ngClass]="language.isSelected ? 'language-word' : 'none'" class="language-word" *ngFor="let language of this.languagesList">
        {{language.name}}
    </h5>
</div>
